import { IListItem } from "../../interfaces/IListItem";
import Skeleton from "../skeleton/skeleton";
import "./listItem.scss";

export interface IListItemProps {
  item: IListItem | null;
  enableResponsiveSearchResults: boolean | null;
}

function ListItem(props: IListItemProps) {
  return (
    <div className="list-item">
      {props.item ? (
        <img
          src={props.item.image.url}
          alt={
            props.item.image.alternateText
              ? props.item.image.alternateText
              : props.item.displayId
          }
        ></img>
      ) : (
        <Skeleton />
      )}
    </div>
  );
}

export default ListItem;
